import { Navigate, Route, Routes } from 'react-router';

import ServiceCatalog from './ServiceCatalog';
import ServiceDetail from './ServiceDetail';

/**
 * Katalog služeb a partnerů (doc/services-catalog.md). Stejné routy pro předsedu i vlastníka –
 * co kdo vidí, rozhoduje BE podle role v budově. Detail je per PARTNER (`:partnerSlug`,
 * volitelně `?offer=<slug>` předvybere službu ve formuláři); staré pevné cesty vedou na přehled.
 */
export const Router: React.FC = () => (
  <Routes>
    <Route index element={<ServiceCatalog />} />
    <Route path=":partnerSlug" element={<ServiceDetail />} />
    <Route path="*" element={<Navigate to="." replace />} />
  </Routes>
);

export default Router;
